<div mat-dialog-title>
  <h1 role="heading" class="screen-reader-only" aria-label="dossier export data prompt">{{title}}</h1>
	<span>{{title}}</span>
</div>
<mat-dialog-content>
	<label class="col-12 text-muted text-sm no-left-padding">
		<input type="checkbox" [(ngModel)]="allPeriodType"(change)="typeChanged()">
		All time
	</label>
	<div style="display: flex; justify-content: center;">
		<label class="col-4 text-muted text-sm">
			Start Date
		</label>
		<div class="col-8 input-group input-group-sm no-left-padding">								
			<input [disabled]="this.allPeriodType" [matDatepicker]="startDatePicker" placeholder="mm/dd/yyyy" class="form-control form-control-sm no-padding"
			[(ngModel)]="startDate" (dateChange)="dateChange('startDate',$event)" [min]="minDate" [max]="!endDate ? maxDate : endDate">
			<mat-datepicker #startDatePicker startView="year"></mat-datepicker>
			<mat-datepicker-toggle [for]="startDatePicker" class="input-group-addon no-padding mat-icon-overide"></mat-datepicker-toggle>
		</div>
	</div>
	<div class="mt-2" style="display: flex; justify-content: center;">
		<label class="col-4 text-muted text-sm" >
			End Date
		</label>
		<div class="col-8 input-group input-group-sm no-left-padding">						
			<input [disabled]="this.allPeriodType" [matDatepicker]="endDatePicker" placeholder="mm/dd/yyyy" class="form-control form-control-sm no-padding"
			[(ngModel)]="endDate" (dateChange)="dateChange('endDate',$event)" [min]="!startDate ? minDate : startDate" [max]="maxDate">
			<mat-datepicker #endDatePicker startView="year"></mat-datepicker>
			<mat-datepicker-toggle [for]="endDatePicker" class="input-group-addon no-padding mat-icon-overide"></mat-datepicker-toggle>
		</div>
	</div>
	<div class="col-12 mt-1" style="display: flex;">
		<div class="text-muted" *ngIf="requirementsMet()">
			<i class="fa fa-check green-check"></i>
			All requirements met
		</div>
		<div *ngIf="!requirementsMet()">
			<div class="alert alert-warning" style="margin-top: 1em;">
				<i class="fa fa-warning"></i>
				{{dossier.ExportStatus.Message}}
			</div>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions>
	<button (click)="cancel()" class="btn btn-link">
		Cancel
	</button>
	<button class="btn btn-primary mr-3" (click)="downloadDoc()" [disabled]="!this.startDate && !this.endDate && !this.allPeriodType">
		<i class="fa fa-fw fa-cloud-download"></i>
		{{exportBtnTxt}}
	</button>
</mat-dialog-actions>
